module.exports = __webpack_public_path__ + "img/KSC09578.a502ed77.jpg";